export function deprecate(component: string, message: string): void {
  const errorMessage = `kitt(${component}): ${message}`;
  if (process.env.KITT_DEPRECATION_ERROR && process.env.KITT_DEPRECATION_ERROR !== 'false') {
    throw new Error(errorMessage);
  } else if (process.env.KITT_IGNORE_DEPRECATION_WARNING !== 'true') {
    console.warn(errorMessage);
  }
}
